import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { RMSvgIconProps } from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';
import { IStyle } from 'Styles';
import './TabItem.scss';

interface Props {
  isActive: boolean;
  children: React.ReactNode;
  onClick: () => void;
  iconProps?: RMSvgIconProps;
  customContainerStyle?: React.CSSProperties;
  isDisabled: boolean;
  tooltip?: string;
  isStartTab?: boolean;
  isEndTab?: boolean;
}

const TabItem = (props: Props) => {
  const {
    isActive,
    children,
    onClick,
    iconProps,
    customContainerStyle,
    isDisabled,
    tooltip,
    isStartTab,
    isEndTab,
  } = props;
  const customItemStyle = { ...styles.customItemStyle, ...customContainerStyle };

  return iconProps ? (
    <div
      id={`tabselector-tabitem-icon-${iconProps.name?.toLowerCase() || 'default'}`}
      className={` padded-div bg-[#313131] ${isActive ? 'bg-[#737373]' : ''} ${
        isStartTab ? 'left-rounded-border' : ''
      } ${isEndTab ? 'right-rounded-border' : ''} `}
    >
      <RMCustomButton
        onClick={onClick}
        iconProps={{ ...iconProps, fill: 'white' }}
        titleTip={tooltip}
      />
    </div>
  ) : (
    <div
      id={`tabselector-tabitem-${typeof children === 'string' ? children.toLowerCase().replace(/\s+/g, '-') : 'text'}`}
      onClick={isDisabled ? null : onClick}
      style={
        isActive
          ? { ...styles.activeItem, ...customItemStyle }
          : isDisabled
          ? { ...styles.disabledItem, ...customItemStyle }
          : customItemStyle
      }
    >
      {children}
    </div>
  );
};

const styles: IStyle = {
  activeItem: {
    backgroundColor: '#85BAFF',
  },
  disabledItem: {
    opacity: 0.5,
  },
  customItemStyle: {
    width: '100%',
    height: '100%',
    cursor: 'pointer',
  },
};

export default TabItem;
